export const projects = [
  {
    slug: "77-east-villa",
    title: "77 East Villa",
    subtitle: "A luminous two-storey home in Bangalore.",
    year: "2019",
    location: "Bangalore, IN",
    role: "Architect · Interior · Furniture",
    materials: ["Traditional Wood", "Floor-to-ceiling Glass", "Custom Furniture"],
    hero: "/portfolio/img/77-02.jpg",
    thumb: "/portfolio/img/77-01.jpg",
    gallery: [
      "/portfolio/img/77-02.jpg",
      "/portfolio/img/77-01.jpg",
      "/portfolio/img/77-03.jpg",
      "/portfolio/img/77-04.jpg",
      "/portfolio/img/77-05.jpg",
    ],
    description:
      "An elegant two-story villa nestled in the heart of Bangalore, seamlessly marrying clean modern aesthetics with a touch of warmth through the incorporation of traditional materials. A double-height space imparts an airy and bright ambience, while floor-to-ceiling French windows add a charming allure. Every piece of furniture and light fitting bears my personal design touch, reflecting a thoughtful and cohesive approach to the entire home.",
    category: "Residence",
  },
  {
    slug: "tea-villa-cafe",
    title: "Tea Villa Cafe",
    subtitle: "A four-storey cafe wrapped in exposed brick and playful colour.",
    year: "2018",
    location: "Bangalore, IN",
    role: "Architect · Interior",
    materials: ["Exposed Brick", "Textured Plaster", "Custom Upholstery"],
    hero: "/portfolio/img/tv-01.jpg",
    thumb: "/portfolio/img/tv-02.jpg",
    gallery: [
      "/portfolio/img/tv-01.jpg",
      "/portfolio/img/tv-02.jpg",
      "/portfolio/img/tv-03.jpg",
      "/portfolio/img/tv-04.jpg",
    ],
    description:
      "A four storey cafe featuring an exposed brick front elevation complemented by a pop of blue textured wall to deliver a striking first impression. The design of this quirky yet elegant cafe combines playful fabrics, prints and textures while preserving a clean and classy ambience that stays genuinely relaxing.",
    category: "Hospitality",
  },
  {
    slug: "hrbr-villa",
    title: "HRBR Villa",
    subtitle: "A 2,260 sq ft sustainable home crafted with local hands.",
    year: "2020",
    location: "Bangalore, IN",
    role: "Architect · Interior",
    materials: ["Exposed Brick", "Stone", "Locally-sourced Wood"],
    hero: "/portfolio/img/hrbr-03.jpg",
    thumb: "/portfolio/img/hrbr-03.jpg",
    gallery: [
      "/portfolio/img/hrbr-01.jpg",
      "/portfolio/img/hrbr-03.jpg",
      "/portfolio/img/hrbr-02.jpg",
    ],
    description:
      "A unique 4BHK independent villa spanning 2260 square feet that stands out as a sustainable and eco-friendly home. Adorned with locally sourced materials and artifacts, the villa is designed to maximise natural light and ventilation, reducing electricity consumption. Rainwater harvesting, solar water heating and drip irrigation sit alongside artisan-crafted fittings, mirrors and light fixtures.",
    category: "Residence",
  },
  {
    slug: "teal-door-cafe",
    title: "The Teal Door Cafe",
    subtitle: "An upcycled cafe empowering women who have endured abuse.",
    year: "2017",
    location: "Bangalore, IN",
    role: "Owner · Architect · Designer",
    materials: ["Upcycled Wood", "Reclaimed Metal", "Hand-thrown Ceramics"],
    hero: "/portfolio/img/td-01.jpg",
    thumb: "/portfolio/img/td-02.jpg",
    gallery: [
      "/portfolio/img/td-01.jpg",
      "/portfolio/img/td-02.jpg",
      "/portfolio/img/td-03.jpg",
    ],
    description:
      "The cafe I own, built to employ women who have endured abuse. Its commitment to sustainability and creativity; all interiors, furniture and lighting have been upcycled and made by hand. A quiet symbol of resilience. Recognised with the 2017 Entrepreneur of the Year award.",
    category: "Cause",
  },
  {
    slug: "mae-terra-goa",
    title: "Mae Terra, Goa",
    subtitle: "A restored Goan heritage house, woven back into the forest.",
    year: "2021",
    location: "Chorao Island, Goa",
    role: "Collaborating Architect (with Renu Mistry)",
    materials: ["Terracotta Tile", "Reclaimed Timber", "Local Laterite Stone"],
    hero: "/portfolio/img/mt-00.jpg",
    thumb: "/portfolio/img/mt-01.jpg",
    gallery: [
      "/portfolio/img/mt-00.jpg",
      "/portfolio/img/mt-01.jpg",
      "/portfolio/img/mt-05.jpg",
      "/portfolio/img/mt-13.jpg",
      "/portfolio/img/mt-02.jpg",
    ],
    description:
      "Nestled in the woods is the charming Goan house 'Mae Terra,' meticulously restored in collaboration with nationally acclaimed architect Renu Mistry. Surrounded by lush forests, a symphony of birds and unique vistas, the restoration was designed to blend seamlessly with its natural surroundings while preserving the authentic vernacular charm. Today it lives on as a boutique retreat operated by Jade Hospitainment.",
    category: "Restoration",
  },
  {
    slug: "earth-alive",
    title: "Earth Alive",
    subtitle: "An 11-acre resort made entirely of repurposed shipping containers.",
    year: "2020",
    location: "Manjalagiri, Tamil Nadu",
    role: "Architect · Interior",
    materials: ["Repurposed Shipping Containers", "Corten Steel", "Grasslands"],
    hero: "/portfolio/img/ea-02.jpg",
    thumb: "/portfolio/img/ea-01.jpg",
    gallery: [
      "/portfolio/img/ea-01.jpg",
      "/portfolio/img/ea-02.jpg",
      "/portfolio/img/ea-03.jpg",
      "/portfolio/img/ea-04.jpg",
      "/portfolio/img/ea-06.jpg",
      "/portfolio/img/ea-08.jpg",
    ],
    description:
      "Aptly named 'Earth Alive,' this project is a bold rewilding experiment, a testament to the fusion of sustainable living and environmental consciousness. Constructed entirely from repurposed shipping containers, seamlessly integrated into the embrace of the natural world.",
    category: "Restoration",
  },
];

/**
 * METHOD.
 *
 * This replaces four one word abstractions: Sustainability, Restoration,
 * Vernacular, Warmth. Every practice site in the world has those four nouns and
 * they commit to nothing, so they read as filler no matter how they are set.
 *
 * Each entry below is a claim with a receipt attached: a specific thing done, on
 * a named project, with the material or the number that proves it. Every fact
 * here is drawn from Shruthi's own portfolio document (uploads/shruthi.txt),
 * lines 81-118. Do not add an entry that cannot point at a project.
 */
export const method = [
  {
    n: "01",
    label: "Made, not ordered",
    body:
      "At HRBR Villa the fittings, the mirrors, the built in furniture and the light fixtures were made by local artists. At 77 East Villa every piece of furniture and every light fitting is my own drawing.",
    evidence: "HRBR Villa · 77 East Villa",
    slug: "hrbr-villa",
    image: "/portfolio/img/77-03.jpg",
  },
  {
    n: "02",
    label: "The house runs on less",
    body:
      "2,260 square feet planned around daylight and cross ventilation, so the electricity bill starts low. Rainwater harvesting, a solar water heater and drip irrigation, built in rather than added on.",
    evidence: "HRBR Villa, Bangalore",
    slug: "hrbr-villa",
    image: "/portfolio/img/hrbr-02.jpg",
  },
  {
    n: "03",
    label: "What was there, stays",
    body:
      "Mae Terra kept its terracotta, its laterite and its timber, and the services were rebuilt behind them. Earth Alive is eleven acres built entirely from repurposed shipping containers.",
    evidence: "Mae Terra, Goa · Earth Alive",
    slug: "mae-terra-goa",
    image: "/portfolio/img/mt-01.jpg",
  },
  {
    n: "04",
    label: "I am still there after opening",
    body:
      "Four of the places on this site are mine to run, which is a different discipline from handing over drawings. At The Teal Door every interior, every piece of furniture and every light was upcycled and made by hand.",
    evidence: "The Teal Door Cafe, Bangalore",
    slug: "teal-door-cafe",
    image: "/portfolio/img/td-02.jpg",
  },
];

/**
 * VENTURES — the commerce layer.
 *
 * Every `booking.href`, phone number, rate and address below was verified against
 * the live venue site on 2026-07-27, and every href returned HTTP 200 with no
 * redirect hops. Do not edit these from memory. Re-verify before shipping:
 *
 *   curl -sI https://jadehospitainment.com/retreat/mae-terra/
 *   curl -sI https://earthalive.in/pricing/
 *   curl -sI https://www.thebalconybar.in/reservations
 *
 * `rates` are published prices. If a venue changes its price and we do not, a guest
 * arrives expecting the wrong number, which is her problem and not ours to create.
 *
 * No WhatsApp links: none of these numbers are confirmed WhatsApp accounts, and a
 * dead wa.me link is worse than no link.
 *
 * ROLE ACCURACY — two roles here are deliberately more conservative than what the
 * generated site claimed, because her own portfolio PDF (uploads/shruthi.txt)
 * contradicted them. Mae Terra was restored BY Renu Mistry, with Shruthi
 * collaborating (PDF line 125). Earth Alive appears under her Dwar Eco Design
 * employment (PDF line 59). If Shruthi confirms a founder or co-founder title in
 * writing, raise them back. Until then these understate rather than overstate.
 */
export const ventures = [
  {
    slug: "mae-terra",
    title: "Mae Terra",
    tagline: "A restored Goan heritage house, inside a bird sanctuary.",
    location: "Chorao Island, Goa",
    year: "Restored 2021",
    role: "Collaborating Architect",
    attribution: "Restored with Renu Mistry · Operated by Jade Hospitainment",
    hero: "/portfolio/img/mt-00.jpg",
    accent: "forest",
    bookable: true,
    booking: {
      label: "Check availability",
      href: "https://jadehospitainment.com/retreat/mae-terra/",
      note: "Rates on enquiry",
    },
    contact: {
      phone: "+918970663366",
      phoneLabel: "089 7066 3366",
      email: "Info@jadehospitainment.com",
    },
    rates: [],
    facts: [
      "Inside the Dr Salim Ali bird sanctuary",
      "Portuguese Goan heritage restoration",
      "Solar power and rainwater harvesting",
      "Private dining and wellness on request",
    ],
    gallery: [
      "/portfolio/img/mt-00.jpg",
      "/portfolio/img/mt-01.jpg",
      "/portfolio/img/mt-05.jpg",
      "/portfolio/img/mt-13.jpg",
      "/portfolio/img/mt-02.jpg",
    ],
    description:
      "A restored Goan Portuguese heritage home turned boutique retreat, on Chorao Island inside a bird sanctuary. Portuguese elegance against earthy material. Open to sky showers, iron spiral staircases, hand painted tiles, and dinner under the mangrove sky.",
  },
  {
    slug: "earth-alive",
    title: "Earth Alive",
    tagline: "Eleven acres of rewilded land, built from shipping containers.",
    location: "Manjalagiri, Tamil Nadu",
    year: "Opened 2020",
    role: "Architect and Interiors",
    attribution: "Designed while at Dwar Eco Design",
    hero: "/portfolio/img/ea-02.jpg",
    accent: "terracotta",
    bookable: true,
    booking: {
      label: "See rates and book",
      href: "https://earthalive.in/pricing/",
      note: "Published rates",
    },
    contact: {
      phone: "+919972291984",
      phoneLabel: "99722 91984",
      phoneAlt: "+919043909215",
      email: "earthalivelab@gmail.com",
      hours: "Mon to Fri, 9am to 6pm · Sat and Sun, 9am to 4pm",
      address: "State Highway 85, Manjalagiri, Tamil Nadu 635110",
    },
    rates: [
      { name: "Tree House", price: "Rs 6,000" },
      { name: "Bunker Nest", price: "Rs 1,500" },
      { name: "Full property", price: "Rs 65,000" },
    ],
    facts: [
      "Eleven acres of rewilded grassland",
      "Built from repurposed shipping containers",
      "Pool, lawns and an amphitheatre",
      "Workshops, retreats and gatherings",
    ],
    gallery: [
      "/portfolio/img/ea-01.jpg",
      "/portfolio/ventures/ea-ampi.jpg",
      "/portfolio/ventures/ea-stay1.jpg",
      "/portfolio/ventures/ea-stay3.jpg",
      "/portfolio/ventures/ea-stay4.jpg",
      "/portfolio/img/ea-04.jpg",
    ],
    description:
      "A versatile destination for gatherings that are meant to be remembered. Workshops, retreats and events on eleven acres of rewilded land, built entirely from repurposed shipping containers set into the landscape rather than on top of it.",
  },
  {
    slug: "balcony-bar",
    title: "The Balcony Bar",
    tagline: "Indiranagar's balcony pub. Open noon until midnight, daily.",
    location: "Indiranagar, Bangalore",
    year: "Est. 2015",
    role: "Owner",
    hero: "/portfolio/ventures/bb-cocktails.jpg",
    /**
     * The only Balcony Bar photography in the repo is scraped thumbnails:
     * bb-cocktails 500x748, bb-food 318x475, bb-beer and bb-mushroom 318x318.
     * Stretched across the venture page hero that is a 5.43x upscale at dpr 2,
     * which looks broken on the one page that takes table reservations.
     *
     * So this venture opens on a typographic hero instead of a photographic
     * one until real photography exists. A considered type panel reads as a
     * decision; a five times upscaled JPEG reads as a mistake. Set this to true
     * the day the venue sends images at 2400px or wider.
     */
    heroPhotographic: false,
    accent: "gold",
    bookable: true,
    booking: {
      label: "Reserve a table",
      href: "https://www.thebalconybar.in/reservations",
      note: "Or call, it is faster",
    },
    contact: {
      phone: "+919632471111",
      phoneLabel: "096 324 71111",
      email: "Enquiry@thebalconybar.in",
      hours: "Noon until midnight, daily",
      instagram: "https://www.instagram.com/the_balcony_bar_/",
    },
    rates: [],
    facts: [
      "Open noon until midnight, daily",
      "Wood fired pizza, biryani, steaks",
      "Indian, Asian and Mediterranean",
      "Full bar at neighbourhood prices",
    ],
    gallery: [
      "/portfolio/ventures/bb-cocktails.jpg",
      "/portfolio/ventures/bb-mushroom.jpg",
      "/portfolio/ventures/bb-food.jpg",
      "/portfolio/ventures/bb-beer.jpg",
    ],
    description:
      "Young, vibrant and a little bohemian. A well stocked bar at neighbourhood prices, and food that runs from Indian and Asian through Mediterranean to wood fired Italian. Open noon until midnight, every day.",
  },
  {
    slug: "teal-door",
    title: "The Teal Door Cafe",
    tagline: "The cafe I built to put thirty two women on a payroll.",
    location: "Bangalore",
    year: "Est. 2017",
    role: "Founder and Designer",
    hero: "/portfolio/img/td-01.jpg",
    accent: "terracotta",
    bookable: false,
    booking: null,
    contact: {},
    rates: [],
    facts: [
      "Entrepreneur of the Year, 2017",
      "Interiors upcycled and handmade",
      "The subject of my TEDx talk",
      "Language training for young people",
    ],
    gallery: [
      "/portfolio/img/td-01.jpg",
      "/portfolio/img/td-02.jpg",
      "/portfolio/img/td-03.jpg",
    ],
    description:
      "The cafe I own, and the reason for everything after it. Four storeys where every piece of furniture and lighting was upcycled and made by hand. It employs the women it was built for and runs language training for young people who are struggling. Awarded Entrepreneur of the Year in 2017.",
  },
];
export const talk = {
  // `title` is YouTube's full string, including its channel suffix. Use it only
  // where the exact video is being identified: the iframe title and the schema.
  title:
    "Someone for Everyone - An Initiative for Change | Shruthi Ravi | TEDxGlobalAcademy",
  // `citedTitle` is the talk's own title, as TED lists it. Use this in copy.
  citedTitle: "Someone for Everyone - An Initiative for Change",
  shortTitle: "Someone for Everyone",
  event: "TEDxGlobalAcademy",
  date: "April 2018",
  channel: "TEDx Talks",
  videoId: "0OJG-Lab4Yk",
  url: "https://www.youtube.com/watch?v=0OJG-Lab4Yk",
  tedUrl:
    "https://www.ted.com/talks/shruthi_ravi_someone_for_everyone_an_initiative_for_change",
  duration: "18 min",
  durationISO: "PT18M33S",
  published: "2018-05-31",
  poster: "/portfolio/img/tedx-poster.jpg",
};

export const press = [
  {
    id: "tedx",
    title: "Someone for Everyone: An Initiative for Change",
    outlet: "TEDxGlobalAcademy",
    year: "2018",
    kind: "Talk",
    url: "https://www.youtube.com/watch?v=0OJG-Lab4Yk",
    excerpt:
      "The story of the women who were making beautiful things out of newspaper and were not being paid what the work was worth, and why the answer was a building rather than a donation.",
  },
  {
    id: "eotf",
    title: "Entrepreneur of the Year",
    outlet: "Bangalore Chapter",
    year: "2017",
    kind: "Award",
    excerpt:
      "Awarded for founding The Teal Door Cafe and building a business model that combined sustainable design with tangible social impact.",
  },
];

export const maeTerra = {
  title: "Mae Terra",
  subtitle: "Operated by Jade Hospitainment · Chorao Island, Goa",
  tagline:
    "A proprietary experience towards unification of mind, body and soul.",
  hero: "/portfolio/img/mt-00.jpg",
  gallery: [
    "/portfolio/img/mt-01.jpg",
    "/portfolio/img/mt-05.jpg",
    "/portfolio/img/mt-13.jpg",
    "/portfolio/img/mt-02.jpg",
    "/portfolio/img/mt-03.jpg",
    "/portfolio/img/mt-04.jpg",
  ],
  chapters: [
    {
      h: "Scenic natural beauty",
      p: "Nestled amid a bird sanctuary, with fishing spots and breathtaking sunrise-to-sunset vistas across the mangroves of Chorao.",
    },
    {
      h: "Exquisite interiors",
      p: "Portuguese elegance against earthy material. Open to sky showers, iron spiral staircases, hand painted azulejo tiles by candlelight.",
    },
    {
      h: "Customised experiences",
      p: "Personalised dining, wellness therapies and entertainment, from stargazing movie nights to karaoke lit by candlelight.",
    },
    {
      h: "Environmental sustainability",
      p: "Rainwater harvesting, solar energy and a considered recycling program. A retreat that respects the forest that hosts it.",
    },
  ],
  contact: {
    website: "jadehospitainment.com/retreat/mae-terra",
    url: "https://jadehospitainment.com/retreat/mae-terra/",
    phone: "+918970663366",
    phoneLabel: "089 7066 3366",
  },
};
